"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var DialogContext = exports.DialogContext = /*#__PURE__*/_react["default"].createContext({
  hasTitle: false
});